import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Workshop2 from "./Workshop2";
import Testimonials from "./Testimonials";
import reviews from "./data";



import cf_1 from "../../Assets/cf_1.png";
import cf_e3 from "../../Assets/cf_e3.png";

import cf_3 from "../../Assets/cf_e1.png";
import cf_4 from "../../Assets/cf_e2.png";




// Import slick-carousel styles
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import SlickLazyImage from "../shared/SlickLazyImage";
import { useTranslation } from "react-i18next";

import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";

const sliderImages = [
   { src: cf_4, alt: "Image 5" },
  { src: cf_1, alt: "Image 1" },
  { src: cf_e3, alt: "Image 2" },
  { src: cf_3, alt: "Image 4" },
 
 



  // Add more images as needed

  ];


function Workshop() {
  const { t } = useTranslation();
  const navigate = useNavigate(); // Initialize navigate

  const [activeSlide, setActiveSlide] = React.useState(0);


  const handleClick = () => {
    navigate("/registration#workshops-section"); // This will navigate to the "/another-page" route
  };

  


  // Settings for the Slick slider
  const settings = {
    dots: true, // Show dots for navigation
    infinite: true, // Infinite loop
    speed: 500, // Transition speed in ms
    slidesToShow: 1, // Show one image at a time
    slidesToScroll: 1, // Scroll one image at a time
    autoplay: true, // Enable autoplay
    autoplaySpeed: 2000, // Time between slides in ms
    pauseOnHover: true,
    pauseOnFocus: true,
    lazyLoad: "ondemand",
    beforeChange: (_current, next) => setActiveSlide(next),
  };



  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
             {/* Second Container with the Image Slider */}
        <Container className="image-slider-container"
            style={{
              // height: "400px",
              paddingTop: "80px",
              background: "transparent", // makes the container background transparent
              position: "relative"
            }}
        
        >
        <Row>
          <Col md={12}>
            <Slider {...settings}>
              {sliderImages.map((image, index) => (
                <div key={index}>
                  <SlickLazyImage
                    src={image.src}
                    alt={t("programs.workshops.sliderAlt")}
                    className="img-fluid"
                    style={{ objectFit: "cover", height: "60%", width: "100%" }}
                    index={index}
                    activeIndex={activeSlide}
                    total={sliderImages.length}
                    buffer={2}
                    eager
                  />
                </div>
              ))}
            </Slider>
          </Col>
        </Row>
      </Container>
      </Container>
      
  

      <Button
    
  onClick={handleClick}
  variant="warning"
  size="lg"
  style={{
    color: "black",
    fontWeight: "bold",
    borderRadius: "0.5rem",
    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
    padding: "0.75rem 1.5rem",
    backgroundColor: "#facc15", // Tailwind yellow-400
    border: "none"
  }}
   className="custom-yellow-btn"
>
  {t("common.registerNow")}
</Button>
      
    

      
          <Workshop2 />

                                        
                    <div className="testimonials">
          <Testimonials reviews={reviews}/>              
          </div>
             

          
           
    </section>
  );
}

export default Workshop;
